import type { ShipmentStatus } from "@/lib/api/types";

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
  }).format(value || 0);
}

export function formatDate(value: string | null | undefined): string {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function formatStatus(status: ShipmentStatus | string): string {
  return String(status)
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

export function statusClass(status: ShipmentStatus | string): string {
  const normalized = String(status);
  if (normalized === "delivered") return "bg-emerald-100 text-emerald-900";
  if (normalized === "in_transit") return "bg-sky-100 text-sky-900";
  if (normalized === "cancelled") return "bg-zinc-200 text-zinc-900";
  if (normalized === "on_hold") return "bg-amber-100 text-amber-900";
  return "bg-slate-100 text-slate-900";
}
